import Card from "components/Card/Card.jsx";
import Select from "react-select";
import Collapsible from "react-collapsible";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import axios from "axios";
import { style } from "../../../variables/Variables";
import React, { Component } from "react";
import LoadingOrder from "views/Components/loadingOrder";
import LoadingMedication from "views/Components/loadingMedication";
import { extendMoment } from "moment-range";
import originalMoment from "moment";
import SweetAlert from "react-bootstrap-sweetalert";
import {
  Col,
  FormControl,
  FormGroup,
  Grid,
  Row,
  Modal,
  ControlLabel,
  Table,
  Pagination,
} from "react-bootstrap";
import {
  getGoodRetunShow,
  getallUsers,
  searchMedicationForOrder,
  SendGoodReturnValue,
  UpdateGoodReturnValue,
  DeleteGoodReturnValue,
} from "api/purchaseOrder/PurchaseOrder";
import {
  getAllMedication,
  getBatchNumberByAllMedicine,
  searchMedicationById,
} from "../../../Listfunction";
import LoadingSpinner from "views/Components/loadingSpinner";
import ScreenLoader from "views/Components/screenLoader";
import LoadingPdfSpinner from "views/Components/loadingPdfSpinner";
import AsyncSelect from "react-select/lib/Async";
import { getApiErrorMessage } from "../../../utils/getApiErrorMessage";
import { forwardRef } from "react";
const moment = extendMoment(originalMoment);

const ForwardedFormControl = forwardRef((props, ref) => (
  <input {...props} ref={ref} />
));

class goodReturnNote extends Component {
  constructor(props) {
    super(props);
    const today = moment();
    this.state = {
      currentPage: 1,
      showGrnPop: false,
      pdfloading: false,
      wrongGoods: false,
      excessGoods: false,
      damageGoods: false,
      other: false,
      isLoading: false,
      OtherNote: "",
      searchUser: [],
      searchUserDeatils: [],
      users: "",
      user_detail: "",
      user_detailsError: null,
      unitprice: "",
      quantity: "",
      subtotal: "",
      basketvalue: "0.00",
      getGoodReturnValue: [],
      supplierList: [],
      username: "",
      loading: false,
      name: "",
      nameError: null,
      mobileno: "",
      mobilenoError: null,
      status: "1",
      statusError: null,
      phoneno: "",
      phonenoError: null,
      email: "",
      emailError: null,
      addressline1: "",
      addressline1Error: null,
      addressline2: "",
      city: "0",
      cityError: null,
      postalcode: "",
      postalcodeError: null,
      country: "0",
      countryError: null,
      latiAndLogitError: null,
      address_form_data: [],
      order_form_detail: [],
      m_id: [],
      companyname: "",
      discount: 0,
      companynote: "",
      _notificationSystem: null,
      cardHidden: true,
      medicationdataList: [],
      lastsubscription: [],
      showModal: false,
      showaddressModal: false,
      subscriptiondetail: [],
      medicationdata: [],
      quanitydata: [],
      addressdata: [],
      address_id: "",
      addressaccess: "0",
      inputList: [],
      alert: null,
      medicationaddError: null,
      marginmodal: false,
      discountmodal: false,
      margintype: "1",
      discountpercentage: 0,
      marginpercentage: 0,
      marginamount: 0,
      b2borganizationdiscount: 0,
      showmediactonModal: false,
      medicationitemcode: "",
      medicationitemcodeError: null,
      medicationdescription: "",
      medicationdescriptionError: null,
      medicationitemname: "",
      medicationitemnameError: null,
      medicationcategory: "0",
      medicationcategoryError: null,
      medicationaddcommision: "1",
      medicationis_featured: "2",
      medicationcity: "0",
      medicationcityError: null,
      medicationprice: 0,
      category_detail: [],
      marginfinalamount: 0,
      displaymarginamount: "",
      displaymarginpercentage: "",
      dynamicfinalpercentage: 0,
      b2baccess: 0,
      city_id: "",
      errormessages: [],
      medicationerrormessage: [],
      addnewaddress: false,
      healthcondition: null,
      paymentoption: null,
      paymentoptionError: null,
      currentMedicineIndex: "",
      selectedUser: null,
      not_get_medicine: "",
      quantity: "",
      medicationOptions: [],
      localMedicationData: [],
      allMedicine: [],

      datarange: moment.range(today.clone(), today.clone().add(7, "days")),

      item_type: "1",
      packageItems: [],
      labpackage: [],
      packageItemss: [],
      totalPage: null,
      wholeReason: "",
      globalOtherNote: "",
      batch_no: "",
      expandedId: null,
      grnStatus: "submitted",
      editingGoodReturnId: null,
    };
    this.selectRefs = [];
    this.medSearchCache = {};
    this.inputRef = React.createRef();
    this.barcodeInputRef = React.createRef();
    this.qtyInputRef = React.createRef();
    this.sellingPriceInputRef = React.createRef();
    this.onSubmit = this.onSubmit.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.medication_item_code_error = React.createRef();
    this.message_error = React.createRef();
    this.inputOnChange = this.inputOnChange.bind(this);
  }
  handleAddClick = () => {
    const selected = this.state.wholeReason || {};
    const globalOther = this.state.globalOtherNote || "";
    var serial = 1;
    this.setState(
      {
        inputList: [
          ...this.state.inputList,
          {
            id: moment().valueOf(),
            srno: this.getSerial(),
            unitprice: "",
            item_type: "1",
            quantity: 1,
            medicationItems: [],
            selectmedication: "",
            wrongGoods: selected && selected.value === "Wrong Goods",
            excessGoods: selected && selected.value === "Excess Goods",
            damageGoods: selected && selected.value === "Damage Goods",
            other: selected && selected.value === "Other",
            OtherNote:
              selected && selected.value === "Other" ? globalOther : "",
          },
        ],
      },
      () => {
        const lastIndex = this.state.inputList.length - 1;
        if (this.selectRefs[lastIndex]) {
          this.selectRefs[lastIndex].focus();
        }
      },
    );
  };

  componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.getTheDataForTheGoodReturnNote(this.state.currentPage);
    this.handleGetAllMedication();
  }
  openModal = () => {
    const defaultRows = [];
    for (let i = 0; i < 3; i++) {
      defaultRows.push({
        id: moment().valueOf() + i,
        srno: i + 1,
        unitprice: "",
        item_type: "1",
        quantity: 1,
        medicationItems: [],
        selectmedication: "",
        wrongGoods: false,
        excessGoods: false,
        damageGoods: false,
        other: false,
        OtherNote: "",
      });
    }
    this.setState(
      {
        showGrnPop: true,
        inputList: defaultRows,
        editingGoodReturnId: null,
        grnStatus: "submitted",
      },
      () => {
        setTimeout(() => {
          if (this.selectRefs[0] && this.selectRefs[0].focus) {
            this.selectRefs[0].focus();
          }
        }, 200);
      },
    );
  };
  handleGetAllMedication = async () => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    const store = token.store_id;
    await getAllMedication(obj, store)
      // .then((response) => response.json())
      .then((response) => {
        const mdata = response.data;
        console.log(response.data, "peracetamol");
        // this.setState({ allMedicine: mdata });
        const medicationOptions = mdata.map((medication) => ({
          value: medication.id,
          label: `${medication.title} (${medication.item_code})`,
        }));
        this.setState({ medicationOptions: medicationOptions });
        this.setState({ localMedicationData: mdata }, () => {
          // build local search index for fast client-side lookups
          if (
            this.state.localMedicationData &&
            this.state.localMedicationData.length > 0
          ) {
            this.buildMedIndex(this.state.localMedicationData);
          }
        });
      });
  };
  soundex(str) {
    if (!str) return "";
    const s = str.toUpperCase().replace(/[^A-Z]/g, "");
    if (s.length === 0) return "";
    const first = s[0];
    const mapping = {
      B: "1",
      F: "1",
      P: "1",
      V: "1",
      C: "2",
      G: "2",
      J: "2",
      K: "2",
      Q: "2",
      S: "2",
      X: "2",
      Z: "2",
      D: "3",
      T: "3",
      L: "4",
      M: "5",
      N: "5",
      R: "6",
    };
    let prev = mapping[first] || "";
    let out = first;
    for (let i = 1; i < s.length && out.length < 4; i++) {
      const ch = s[i];
      const code = mapping[ch] || "0";
      if (code === prev) continue;
      if (code !== "0") {
        out += code;
      }
      prev = code;
    }
    // pad with zeros
    return out.padEnd(4, "0").slice(0, 4);
  }
  buildMedIndex = (medArray) => {
    try {
      this.medIndex = medArray.map((m) => {
        const label = `${m.title} (${m.item_code})`;
        const labelLower = (label || "").toLowerCase();
        let sdx = "";
        try {
          sdx = this.soundex(labelLower);
        } catch (e) {
          sdx = "";
        }
        return { value: m.id, label, labelLower, soundex: sdx };
      });
      // sort for stable prefix scanning
      this.medIndex.sort((a, b) => (a.labelLower > b.labelLower ? 1 : -1));
    } catch (e) {
      this.medIndex = [];
    }
  };
  loadMedicationOptions = (inputValue) => {
    // require at least 2 characters to reduce work
    if (!inputValue || inputValue.trim().length < 2) return Promise.resolve([]);

    const q = inputValue.trim();

    // return cached result when available
    if (this.medSearchCache[q]) {
      return Promise.resolve(this.medSearchCache[q]);
    }

    // ensure medIndex is built from localMedicationData when available
    if (
      (!this.medIndex || this.medIndex.length === 0) &&
      this.state.localMedicationData &&
      this.state.localMedicationData.length > 0
    ) {
      this.buildMedIndex(this.state.localMedicationData);
    }

    // debounce filter: returns a promise resolved after debounce
    return new Promise((resolve) => {
      if (this._loadMedTimer) clearTimeout(this._loadMedTimer);
      this._loadMedTimer = setTimeout(() => {
        // If we have local data index, filter locally (fast)
        if (this.medIndex && this.medIndex.length > 0) {
          const lower = q.toLowerCase();
          const results = [];
          const LIMIT = 50;

          // 1) prefix matches
          for (
            let i = 0;
            i < this.medIndex.length && results.length < LIMIT;
            i++
          ) {
            const m = this.medIndex[i];
            if (m.labelLower.startsWith(lower)) results.push(m);
          }

          // 2) substring matches
          if (results.length < LIMIT) {
            for (
              let i = 0;
              i < this.medIndex.length && results.length < LIMIT;
              i++
            ) {
              const m = this.medIndex[i];
              if (results.indexOf(m) !== -1) continue;
              if (m.labelLower.includes(lower)) results.push(m);
            }
          }

          // 3) phonetic soundex fallback for longer queries
          if (results.length === 0 && lower.length >= 3) {
            const qSound = this.soundex(lower);
            for (
              let i = 0;
              i < this.medIndex.length && results.length < LIMIT;
              i++
            ) {
              const m = this.medIndex[i];
              if (m.soundex && m.soundex === qSound) results.push(m);
            }
          }

          const options = results.map((m) => ({
            value: m.value,
            label: m.label,
          }));

          // cache limited queries
          try {
            const keys = Object.keys(this.medSearchCache);
            if (keys.length > 200) delete this.medSearchCache[keys[0]];
            this.medSearchCache[q] = options;
          } catch (e) {}

          return resolve(options);
        }

        // fallback: call API once (debounced) if no local data
        this.medSearchRequestSeq++;
        const reqSeq = this.medSearchRequestSeq;
        try {
          const token = JSON.parse(localStorage.getItem("user"));
          const obj = token ? token.token : null;
          const city_id = this.state.city_id || 1;

          searchMedicationForOrder(q, city_id, 1, obj, this.state.store)
            .then((res) => {
              if (reqSeq !== this.medSearchRequestSeq) return resolve([]);
              const data = (res.data && res.data.data) || [];
              const options = data.map((medication) => ({
                value: medication.id,
                label: `${medication.title} (${medication.item_code})`,
              }));
              try {
                const keys = Object.keys(this.medSearchCache);
                if (keys.length > 200) delete this.medSearchCache[keys[0]];
                this.medSearchCache[q] = options;
              } catch (e) {}
              resolve(options);
            })
            .catch(() => resolve([]));
        } catch (e) {
          resolve([]);
        }
      }, 200);
    });
  };

  handleReasonOnChange = (e) => {
    const { name, value, checked } = e.target;

    const updatedList = this.state.inputList.map((data) => {
      if (data.id === Number(value)) {
        const updatedData = {
          ...data,
          wrongGoods: false,
          excessGoods: false,
          damageGoods: false,
          other: false,
        };

        updatedData[name] = checked;

        return updatedData;
      }
      return data;
    });

    this.setState({ inputList: updatedList });
  };

  handleOtherNoteChange(e, id) {
    const updatedList = this.state.inputList.map((data) => {
      if (data.id === id) {
        return {
          ...data,
          OtherNote: e.target.value,
        };
      }
      return data;
    });

    this.setState({ inputList: updatedList });
  }

  resetSearch() {
    this.setState({
      name: "",
    });
  }

  searchData(e) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    this.setState({ noRecordFound: false, loading: true }, () => {
      getallUsers(this.state.name, this.state.page, obj).then((res) => {
        const dontShowThisRole = [8, 4];
        const filteredData = res.data.data.filter((x) =>
          dontShowThisRole.includes(x.role),
        );

        const searchUser = filteredData.map((x) => ({
          value: x.id,
          label: x.name,
        }));

        const { current_page, last_page, next_page_url, prev_page_url } =
          res.data;

        const paginationData = Array.from(
          { length: last_page },
          (_, i) => i + 1,
        );

        const nextdisabled = current_page === last_page ? "1" : null;
        const prevdisabled = current_page === 1 ? "1" : null;

        this.setState({
          searchUserDeatils: filteredData,
          searchUser: searchUser,
          paginationData: paginationData,
          currentPage: current_page,
          nextdisabled: nextdisabled,
          prevdisabled: prevdisabled,
          nextpage: next_page_url ? next_page_url.split("=").pop() : "#",
          prevpage: prev_page_url ? prev_page_url.split("=").pop() : "#",
          loading: false,
          user_detail: "",
        });

        if (filteredData.length === 0) {
          this.setState({
            noRecordFound: true,
            nextdisabled: "1",
            prevdisabled: "1",
            paginationData: [],
          });
        }
      });
    });
  }

  inputOnChange = (event, i) => {
    const self = this;

    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }

    self.setState({
      name: event.target.value.trim(),
      typing: false,
      typingTimeout: setTimeout(function () {
        self.sendToParent(self.state.name.trim(), i);
      }, 500),
    });
  };
  setInputRef = (el, index) => {
    if (!this.inputRef.current) {
      this.inputRef.current = {};
    }
    this.inputRef.current[index] = el;
  };
  handleWholeReasonChange = (selected) => {
    this.setState({ wholeReason: selected });

    const updatedList = this.state.inputList.map((item) => {
      return {
        ...item,
        wrongGoods: selected.value === "Wrong Goods",
        excessGoods: selected.value === "Excess Goods",
        damageGoods: selected.value === "Damage Goods",
        other: selected.value === "Other",
        OtherNote:
          selected.value === "Other" ? this.state.globalOtherNote || "" : "",
      };
    });

    this.setState({ inputList: updatedList });
  };

  // handleSelectChange = (index, value) => {
  //   let name = "description";
  //   const list = [...this.state.inputList];
  //   list[index][name] = value.value;
  //   var temp_arr = [];

  //   if (list[index]["item_type"] == "1") {
  //     this.state.medication_detail.map((pac) => {
  //       if (list[index]["description"] == pac.id) {
  //         list[index]["unitprice"] = parseFloat(pac.price - 0).toFixed(2);
  //       }
  //     });

  //     list[index]["medicationItems"] = temp_arr;
  //     list[index]["selectmedication"] = value;

  //     const data = this.state.medication_detail[index].map((medi) => {
  //       if (list[index]["description"] == medi.id) {
  //         list[index]["unitprice"] = parseFloat(medi.unit_price - 0).toFixed(2);

  //         list[index]["total_quantity"] = medi.total_quantity;
  //         list[index]["availableQuantity"] = medi.total_quantity;
  //         list[index]["total_allocated"] = medi.total_allocated;

  //         list[index]["selling_price"] = medi.price;
  //         list[index]["barcode"] = medi.barcode;
  //       }
  //     });

  //     list[index]["subtotal"] =
  //       list[index]["unitprice"] * list[index]["quantity"];
  //     list[index]["subtotal"] = list[index]["subtotal"].toFixed(2);

  //     this.setState({ inputList: list, totalcost: "", discountamount: 0 });

  //     var new_array = this.state.medicationItems;
  //     new_array[index] = [];
  //     this.setState({ medicationItems: new_array });
  //   } else if (list[index]["item_type"] == "2") {
  //     this.state.labpackage.map((repo) => {
  //       if (list[index]["description"] == repo.id) {
  //         list[index]["unitprice"] = parseFloat(repo.price - 0).toFixed(2);
  //       }
  //     });

  //     list[index]["medicationItems"] = temp_arr;
  //     list[index]["selectmedication"] = value;
  //     const data = this.state.labpackage.map((medi) => {
  //       if (list[index]["description"] == medi.id) {
  //         list[index]["unitprice"] = parseFloat(medi.unit_price - 0).toFixed(2);
  //         list[index]["total_quantity"] = medi.total_quantity;
  //         list[index]["availableQuantity"] = medi.quantity;
  //         list[index]["selling_price"] = medi.price;
  //       }
  //     });

  //     list[index]["subtotal"] =
  //       list[index]["unitprice"] * list[index]["quantity"];
  //     list[index]["subtotal"] = list[index]["subtotal"].toFixed(2);

  //     this.setState({ inputList: list, totalcost: "", discountamount: 0 });

  //     var new_array = this.state.medicationItems;
  //     new_array[index] = [];
  //     this.setState({ medicationItems: new_array });
  //   }
  //   setTimeout(() => {
  //     if (this.selectRefs[index + 1]) {
  //       this.selectRefs[index + 1].focus();
  //     }
  //   }, 100);
  // };

  handleBarcodeNoChange = (event, id, index) => {
    const self = this;

    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }

    if (event.target.value[0] === "F") {
      self.setState({
        name: event.target.value.trim(),
        typing: false,
        typingTimeout: setTimeout(function () {
          self.sendToParentBarcodeNot(self.state.name, index);
        }, 500),
      });
    } else {
      self.setState({
        name: event.target.value.substring(1, 7).trim(),
        typing: false,
        typingTimeout: setTimeout(function () {
          self.sendToParentBarcode(self.state.name, index);
        }, 500),
      });
    }
  };

  // sendToParentBarcode = async (name, i) => {
  //   if (this.state.name.length !== 0) {
  //     const list = [...this.state.inputList];
  //     var madpackageItem = [];

  //     if (list[i]["item_type"] == "1") {
  //       let compelte = 1;
  //       let pg_no = 1;
  //       const token = JSON.parse(localStorage.getItem("user"));
  //       const obj = token.token;
  //       var city_id = this.state.city_id;
  //       await searchMedicationForOrder(
  //         this.state.name,
  //         city_id,
  //         pg_no,
  //         obj
  //       ).then(async (res) => {
  //         const list = [...this.state.inputList];

  //         var mdata = res.data.data;

  //         var medicationItems = [];

  //         this.setState({ medication_detail: [] });

  //         res.data.data.map(async (x, i) => {
  //           medicationItems.push({
  //             value: x.id,
  //             label: x.title + "(" + x.item_code + ")",
  //           });
  //         });
  //         list[i]["medicationItems"] = medicationItems;
  //         this.setState({ inputList: list });

  //         var mew_arr = this.state.medicationItems;
  //         mew_arr[i] = medicationItems;
  //         var array1md = this.state.medication_detail;
  //         var array2md = array1md.concat(res.data.data);
  //         var medi_array = [];
  //         medi_array[i] = array2md;

  //         this.setState({
  //           medication_detail: medi_array,
  //           medicationItems: mew_arr,
  //         });
  //         if (medicationItems.length === 1) {
  //           this.handleSelectChange(i, medicationItems[0]);
  //         } else if (medicationItems.length > 1) {
  //           if (this.inputRef.current && this.inputRef.current[i]) {
  //             this.inputRef.current[i].focus();
  //             this.inputRef.current[i].onMenuOpen();
  //           }
  //         }
  //       });
  //     } else if (list[i]["item_type"] == "2") {
  //       this.state.packageItems.map((x, i) => {
  //         madpackageItem.push({
  //           value: x.value,
  //           label: x.label,
  //         });
  //       });
  //       list[i]["medicationItems"] = madpackageItem;
  //     }

  //     this.setState({ inputList: list });
  //     if (list[i]["barcode"]) {
  //       const removeFirstDigit = list[i]["barcode"].slice(1);
  //       if (name === removeFirstDigit) {
  //         this.handleAddClick();
  //       }
  //     }
  //   } else {
  //     const list = [...this.state.inputList];
  //     list[i]["medicationItems"] = [];
  //     this.setState({ inputList: list });
  //     this.setState({ medication_detail: [], medicationItems: [] });
  //   }
  // };
  handleInputChange = (e, index, type) => {
    const { name, value } = e.target;
    const list = [...this.state.inputList];

    list[index][name] = value;

    var subtotal = list[index]["unitprice"] * list[index]["quantity"];
    var addmargin = 0;
    list[index]["subtotal"] =
      (parseFloat(list[index]["unitprice"]) + parseFloat(addmargin)) *
      list[index]["quantity"];
    list[index]["subtotal"] = list[index]["subtotal"].toFixed(2);
    this.setState({
      inputList: list,
    });
  };
  handleMedicineSelectChange = async (selectedOption, index) => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token ? token.token : null;
    const list = [...this.state.inputList];
    let itemId = 0;
    const findSelectedMedicine = this.state.localMedicationData.find(
      (med) => med.id === selectedOption.value,
    );

    if (!findSelectedMedicine) {
      return;
    }

    const storeWiseMedication = Array.isArray(
      findSelectedMedicine.store_wise_medication,
    )
      ? findSelectedMedicine.store_wise_medication
      : [];

    console.log("storeWiseMedication", storeWiseMedication);

    const getPharmacyLevelQuantity = storeWiseMedication.find(
      (med) =>
        med.pharmacies && med.pharmacies.name === "Flash Health Pharmacy",
    );
    console.log("getPharmacyLevelQuantity", getPharmacyLevelQuantity);

    const getStoreLevelQuantity = storeWiseMedication.find(
      (med) => med.pharmacies && med.pharmacies.name === "Flash WareHouse",
    );
    console.log("getStoreLevelQuantity", getStoreLevelQuantity);
    const newData = await searchMedicationById(obj, selectedOption.value);
    let batches = [];
    const getTotalQuantity =
      findSelectedMedicine &&
      storeWiseMedication.reduce((acc, curr) => acc + curr.quantity, 0);
    if (
      newData.data.data.medication_batches &&
      newData.data.data.medication_batches.length > 0
    ) {
      batches = newData.data.data.medication_batches || [];
    } else {
      batches = [
        {
          medication_id: selectedOption.value,
          batch_no: "",
          quantity: getTotalQuantity || 0,
          item_code: "F-000017",
          expiry_date: "",
        },
      ];
    }
    console.log(findSelectedMedicine, "findSelectedMedicine");
    console.log(newData, "newData");
    if (findSelectedMedicine) {
      const addDetails = list.map((item, idx) => {
        if (idx === index) {
          itemId = item.id;
          return {
            ...item,
            description: selectedOption,
            unitprice: parseFloat(findSelectedMedicine.price - 0).toFixed(2),
            total_quantity: findSelectedMedicine.total_quantity,
            availableQuantity: Number(findSelectedMedicine.total_quantity),
            total_allocated: Number(findSelectedMedicine.total_allocated),
            selling_price: findSelectedMedicine.price,
            barcode: findSelectedMedicine.item_code,
            pharmacyLevelQty: getPharmacyLevelQuantity
              ? getPharmacyLevelQuantity.quantity
              : 0,
            storeLevelQty: getStoreLevelQuantity
              ? getStoreLevelQuantity.quantity
              : 0,
            subtotal: Number(
              parseFloat(findSelectedMedicine.price - 0).toFixed(2) *
                item.quantity,
            ).toFixed(2),
            medicinBatchesdata: batches,
          };
        }
        return item;
      });

      const availableQuantity = Number(findSelectedMedicine.total_quantity);
      if (
        Number(list[index]["quantity"]) > availableQuantity ||
        0 === availableQuantity
      ) {
        this.setState({ isOverQuantity: index });
      } else {
        this.setState({ isOverQuantity: "" });
      }
      this.setState(
        {
          inputList: addDetails,
          medicinBatchesdata: findSelectedMedicine.batches,
          expandedId: itemId,
        },
        () => {
          // Focus selling price input after state update if this was triggered by barcode scan
          if (index !== null) {
            setTimeout(() => {
              console.log("Focusing selling price input at index:", index);
              this.focusSellingPriceInput(index, 0);
            }, 300);
          }
        },
      );
    }
  };

  handleRemoveClick = (index) => {
    const list = [...this.state.inputList];
    list.splice(index, 1);
    this.setState({ inputList: list });
  };

  handleEditGoodReturnNote = (goodReturnNote) => {
    // Set user detail with supplier info
    const user_detail = {
      id: goodReturnNote.user_id,
      label: goodReturnNote.supplier ? goodReturnNote.supplier.name : "",
    };
    let itemId = 0;

    // Transform good_return_items to inputList format
    const inputList = goodReturnNote.good_return_items.map((item, index) => {
      // Map reason to checkbox values
      const reasonLower = (item.reason || "").toLowerCase();
      const isWrongGoods = reasonLower.includes("wrong");
      const isExcessGoods = reasonLower.includes("excess");
      const isDamageGoods = reasonLower.includes("damage");
      const isOther = !isWrongGoods && !isExcessGoods && !isDamageGoods;
      const getPharmacyLevelQuantity = item.store_wise_medications.find(
        (med) =>
          med.pharmacies && med.pharmacies.name === "Flash Health Pharmacy",
      );
      console.log("getPharmacyLevelQuantity", getPharmacyLevelQuantity);

      const getStoreLevelQuantity = item.store_wise_medications.find(
        (med) => med.pharmacies && med.pharmacies.name === "Flash WareHouse",
      );
      console.log("getStoreLevelQuantity", getStoreLevelQuantity);
      const getTotalQuantity =
        item &&
        item.store_wise_medications.reduce(
          (acc, curr) => acc + curr.quantity,
          0,
        );
      let batches = [];
      if (item.medication_batches && item.medication_batches.length > 0) {
        // Create a map to track which batches we've already matched for handling duplicates
        const batchMatchCountMap = {};

        // Map medication_batches and populate qty from item.batches
        batches = item.medication_batches.map((medBatch) => {
          // For duplicate batch numbers, find the matching occurrence
          const batchKey = medBatch.batch_no;
          const currentCount = batchMatchCountMap[batchKey] || 0;
          batchMatchCountMap[batchKey] = currentCount + 1;

          // Find all matching batches from item.batches with same batch_no
          const matchingBatches =
            item.batches &&
            item.batches.filter(
              (batch) => batch.batch_no === medBatch.batch_no,
            );

          // Get the matching batch at the current index
          const matchingBatch =
            matchingBatches && matchingBatches[currentCount];

          // Set qty from item.batches if found, otherwise use quantity field
          return {
            ...medBatch,
            qty: matchingBatch ? matchingBatch.quantity : 0,
          };
        });
      } else {
        batches = [
          {
            medication_id: item.med_id,
            batch_no: "",
            quantity: getTotalQuantity || 0,
            item_code: "F-000017",
            expiry_date: "",
            qty: 0,
          },
        ];
      }

      itemId = item.id;
      return {
        id: moment().valueOf() + index,
        good_return_item_id: item.id,
        srno: index + 1,
        description: {
          value: item.med_id,
          label: item.medication_Name || "",
        },
        selectmedication: {
          value: item.med_id,
          label: item.medication_Name || "",
        },
        unitprice: item.unit_price || "",
        quantity: Number(item.quantity) || 1,
        medicationItems: [],
        wrongGoods: isWrongGoods,
        excessGoods: isExcessGoods,
        damageGoods: isDamageGoods,
        other: isOther,
        OtherNote: isOther ? item.reason : "",
        subtotal: (
          Number(item.unit_price || 0) * Number(item.quantity || 1)
        ).toFixed(2),
        barcode: item.item_code || "",
        item_type: "1",
        pharmacyLevelQty: getPharmacyLevelQuantity
          ? getPharmacyLevelQuantity.quantity
          : 0,
        storeLevelQty: getStoreLevelQuantity
          ? getStoreLevelQuantity.quantity
          : 0,
        medicinBatchesdata: batches,
      };
    });

    // Determine the whole reason
    let wholeReason = null;
    if (inputList.length > 0) {
      if (inputList[0].wrongGoods)
        wholeReason = { value: "Wrong Goods", label: "Wrong Goods" };
      else if (inputList[0].excessGoods)
        wholeReason = { value: "Excess Goods", label: "Excess Goods" };
      else if (inputList[0].damageGoods)
        wholeReason = { value: "Damage Goods", label: "Damage Goods" };
      else if (inputList[0].other)
        wholeReason = { value: "Other", label: "Other" };
    }

    // Get other note if reason is "Other"
    const globalOtherNote =
      inputList.length > 0 && inputList[0].other ? inputList[0].OtherNote : "";

    // Update state and open modal
    this.setState({
      showGrnPop: true,
      user_detail: user_detail,
      inputList: inputList,
      wholeReason: wholeReason || "",
      globalOtherNote: globalOtherNote,
      searchUser: [],
      expandedId: itemId,
      editingGoodReturnId: goodReturnNote.id,
      grnStatus: goodReturnNote.status || "submitted",
    });
  };

  serial = 1;
  getSerial() {
    return this.serial++;
  }
  // sendToParent = async (name, i) => {
  //   if (this.state.name.length !== 0) {
  //     const list = [...this.state.inputList];
  //     var madpackageItem = [];

  //     if (list[i]["item_type"] == "1") {
  //       let compelte = 1;
  //       let pg_no = 1;
  //       var token = JSON.parse(localStorage.getItem("user"));

  //       const obj = token.token;
  //       var city_id = this.state.city_id;
  //       await searchMedicationForOrder(
  //         this.state.name,
  //         city_id,
  //         pg_no,
  //         obj
  //       ).then((res) => {
  //         const list = [...this.state.inputList];
  //         var mdata = res.data.data;
  //         var medicationItems = [];

  //         this.setState({ medication_detail: [] });
  //         res.data.data.map(async (x, i) => {
  //           medicationItems.push({
  //             value: x.id,
  //             label: x.title + "(" + x.item_code + ")",
  //           });
  //         });
  //         list[i]["medicationItems"] = medicationItems;
  //         this.setState({ inputList: list });

  //         var mew_arr = [];
  //         mew_arr[i] = medicationItems;
  //         var array1md = this.state.medication_detail;
  //         var array2md = array1md.concat(res.data.data);
  //         var medi_array = [];
  //         medi_array[i] = array2md;

  //         this.setState({
  //           medication_detail: medi_array,
  //           medicationItems: mew_arr,
  //         });
  //         if (medicationItems.length === 1) {
  //           this.handleSelectChange(i, medicationItems[0]);
  //         }
  //       });
  //     } else if (list[i]["item_type"] == "2") {
  //       this.state.packageItems.map((x, i) => {
  //         madpackageItem.push({
  //           value: x.value,
  //           label: x.label,
  //         });
  //       });
  //       list[i]["medicationItems"] = madpackageItem;
  //     }

  //     this.setState({ inputList: list });
  //   } else {
  //     const list = [...this.state.inputList];
  //     list[i]["medicationItems"] = [];
  //     this.setState({ inputList: list });
  //     this.setState({ medication_detail: [], medicationItems: [] });
  //   }
  // };

  closeModal = () => {
    this.setState({
      showGrnPop: false,
      inputList: [],
      name: "",
      user_detail: "",
      user_detailsError: null,
      wholeReason: "",
      globalOtherNote: "",
      editingGoodReturnId: null,
      grnStatus: "submitted",
    });
  };

  onSubmit() {
    this.setState({ errormessages: [] });
    let error = false;
    const filledRows = this.state.inputList.filter(
      (row) => row.description && row.description.value,
    );
    console.log(filledRows, "fillrow");

    if (!this.state.user_detail.label) {
      error = true;
      this.setState({
        user_detailsError: (
          <small className="text-danger" style={{ padding: "3px" }}>
            User is required.
          </small>
        ),
      });
    } else {
      this.setState({ user_detailsError: null });
    }

    if (filledRows.length === 0) {
      error = true;
      this.setState({
        alert: (
          <SweetAlert
            className="order_alert"
            style={{ display: "block", marginTop: "-100px" }}
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="info"
          >
            <h4>Please Enter Proper Medication data!</h4>
          </SweetAlert>
        ),
      });
    } else {
      filledRows.forEach((x) => {
        if (x.description && !x.description.value) {
          error = true;
          this.setState({
            alert: (
              <SweetAlert
                className="order_alert"
                style={{ display: "block", marginTop: "-100px" }}
                onConfirm={() => this.hideAlert()}
                onCancel={() => this.hideAlert()}
                confirmBtnBsStyle="info"
              >
                <h4>Please Enter Proper Medication data!</h4>
              </SweetAlert>
            ),
          });
        }
      });
    }
    const isApprovedStatus =
      String(this.state.grnStatus || "").toLowerCase() === "approved";
    const invalidQuantities = isApprovedStatus
      ? filledRows.filter(
          (item) =>
            Number(item.storeLevelQty + item.pharmacyLevelQty) <
            Number(item.quantity),
        )
      : [];
    if (invalidQuantities.length > 0) {
      error = true;

      this.setState({
        alert: (
          <SweetAlert
            className="order_alert"
            style={{ display: "block", marginTop: "-100px" }}
            onConfirm={() => this.hideAlert()}
            confirmBtnBsStyle="info"
          >
            <h4>
              The Following Medications Have Insufficient Quantities :{" "}
              {invalidQuantities.map((name, index) => (
                <p key={index} style={{ marginTop: "7px" }}>
                  {name.description && name.description.label} Stock :{" "}
                  {Number(name.storeLevelQty) + Number(name.pharmacyLevelQty)}
                </p>
              ))}
            </h4>
          </SweetAlert>
        ),
      });
    }

    if (!error) {
      this.setState({ isLoading: true });

      const token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      let store = "";
      console.log("filledRows", filledRows);
      let orderItemsform = filledRows.map((x) => {
        const batches = Array.isArray(x.batches)
          ? x.batches
          : Array.isArray(x.medicinBatchesdata)
            ? x.medicinBatchesdata
            : [];

        return {
          id: x.good_return_item_id,
          batches: batches
            .filter(
              (batch) => Number(batch.qty || batch.return_quantity || 0) > 0,
            )
            .map((batch) => ({
              batch_no: batch.batch_no,
              expiry_date: batch.expiry_date,
              quantity: Number(batch.qty || batch.return_quantity || 0),
              store_id:
                batch.storeId ||
                batch.store_id ||
                (batch.pharmacies && batch.pharmacies.id) ||
                null,
            })),
          item_code: x.barcode || "",
          medication_Name: x.description && x.description.label,
          quantity: x.quantity,
          unit_price: x.unitprice || "",
          med_id: x.description && x.description.value,
          store_id: store,
          reason: x.wrongGoods
            ? "Wrong good"
            : x.damageGoods
              ? "Damage goods"
              : x.excessGoods
                ? "Excess goods"
                : x.OtherNote || "",
        };
      });
      this.setState({ processing: true }, () => {
        const payload = {
          items: orderItemsform,
          user_id: this.state.user_detail.id,
          status: this.state.grnStatus,
        };
        const request = this.state.editingGoodReturnId
          ? UpdateGoodReturnValue(obj, this.state.editingGoodReturnId, payload)
          : SendGoodReturnValue(obj, payload);

        request
          .then(() => {
            this.setState({
              processing: false,
              inputList: [],
              name: "",
              user_detail: "",
              showGrnPop: false,
              isLoading: false,
              wholeReason: "",
              globalOtherNote: "",
              editingGoodReturnId: null,
              grnStatus: "submitted",
            });
            this.getTheDataForTheGoodReturnNote(this.state.currentPage);
          })
          .catch((error) => {
            console.error(
              "API Error:",
              error.response ? error.response.data : getApiErrorMessage(error),
            );
            this.setState({
              processing: false,
              isLoading: false,
            });
          });
      });
    }
  }

  hideAlert() {
    this.setState({
      alert: null,
    });
  }

  confirmDeleteGoodReturnNote = (id) => {
    this.setState({
      alert: (
        <SweetAlert
          warning
          showCancel
          className="order_alert"
          style={{ display: "block", marginTop: "-100px" }}
          confirmBtnText="Yes, delete it!"
          cancelBtnText="Cancel"
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="default"
          onConfirm={() => this.handleDeleteGoodReturnNote(id)}
          onCancel={() => this.hideAlert()}
        >
          <h4>Do you want to delete this good return note?</h4>
        </SweetAlert>
      ),
    });
  };

  handleDeleteGoodReturnNote = (id) => {
    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    this.setState({ alert: null, loading: true });

    DeleteGoodReturnValue(obj, id)
      .then(() => {
        const getGoodReturnValue = this.state.getGoodReturnValue.filter(
          (goodReturnNote) => goodReturnNote.id !== id,
        );

        this.setState({
          getGoodReturnValue,
          loading: false,
          noRecordFound: getGoodReturnValue.length === 0,
          alert: (
            <SweetAlert
              success
              className="order_alert"
              style={{ display: "block", marginTop: "-100px" }}
              confirmBtnBsStyle="info"
              onConfirm={() => this.hideAlert()}
            >
              <h4>Good return note deleted successfully.</h4>
            </SweetAlert>
          ),
        });
        this.getTheDataForTheGoodReturnNote(this.state.currentPage);
      })
      .catch((error) => {
        console.error(
          "Delete API Error:",
          error.response ? error.response.data : getApiErrorMessage(error),
        );
        this.setState({
          loading: false,
          alert: (
            <SweetAlert
              danger
              className="order_alert"
              style={{ display: "block", marginTop: "-100px" }}
              confirmBtnBsStyle="danger"
              onConfirm={() => this.hideAlert()}
            >
              <h4>Could not delete the good return note.</h4>
            </SweetAlert>
          ),
        });
      });
  };

  inputOnChangeUser = (event) => {
    const self = this;

    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }

    self.setState({
      name: event.target.value.trim(),
      typing: false,
      typingTimeout: setTimeout(function () {
        self.searchData(self.state.name);
      }, 300),
    });
  };
  onUserChange = (value) => {
    this.setState({
      user_detail: {
        id: value.value || "",
        label: value.label || "",
      },
      searchUser: [],
      user_detailsError: null,
    });
  };
  getTheDataForTheGoodReturnNote(currenPage) {
    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    getGoodRetunShow(obj, currenPage)
      .then((res) => {
        const goodReturnNotes = Array.isArray(res.data.data)
          ? res.data.data
          : [];
        const getGoodReturnValue = goodReturnNotes.filter(
          (goodReturnNote) => !goodReturnNote.deleted_at,
        );
        this.setState({
          getGoodReturnValue,
          noRecordFound: getGoodReturnValue.length === 0,
        });
      })
      .catch((error) => {
        console.error("Error fetching Good Return Note data:", error);
      });
  }
  paginationHandler() {
    let active = this.state.currentPage;
    let items = [];
    for (let number = 1; number <= this.state.totalPage; number++) {
      items.push(
        <Pagination.Item
          onClick={() => {
            this.setState({ currentPage: number });
            this.getTheDataForTheGoodReturnNote(number);
          }}
          active={number === active}
        >
          {number}
        </Pagination.Item>,
      );
    }
    return items;
  }

  viewPDF(pdfUrl) {
    if (pdfUrl) {
      window.open(pdfUrl, "_blank");
    } else {
      console.error("PDF is not available");
    }
  }
  handleGlobalOtherNote = (e) => {
    const value = e.target.value;
    this.setState({ globalOtherNote: value });
    const updatedList = this.state.inputList.map((item) => {
      if (item.other) {
        return {
          ...item,
          OtherNote: value,
        };
      }
      return item;
    });
    this.setState({ inputList: updatedList });
  };

  toggleExpand = (id) => {
    this.setState((prevState) => ({
      expandedId: prevState.expandedId === id ? null : id,
    }));
  };
  handleBatchNumber = async (value, scannedIndex = null) => {
    console.log("handleBatchNumber", value, "scannedIndex:", scannedIndex);
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    if (value !== "") {
      try {
        const data = await getBatchNumberByAllMedicine(obj, value);

        if (
          (data && data.status === 404) ||
          (data && data.data && data.data.status === 404)
        ) {
          this.setState({
            alert: (
              <SweetAlert
                className="order_alert"
                style={{ display: "block", marginTop: "-100px" }}
                onConfirm={() => this.hideAlert()}
                onCancel={() => this.hideAlert()}
                confirmBtnText="OK"
                confirmBtnBsStyle="danger"
              >
                <h4>No medicine found for this batch number.</h4>
              </SweetAlert>
            ),
          });
          return;
        }

        console.log("Batch number data response:", data);
        console.log("data", data.data.data);
        const getPharmacyLevelQuantity =
          data.data.data.medication.store_wise_medication.find(
            (med) =>
              med.pharmacies && med.pharmacies.name === "Flash Health Pharmacy",
          );

        const getStoreLevelQuantity =
          data.data.data.medication.store_wise_medication.find(
            (med) =>
              med.pharmacies && med.pharmacies.name === "Flash WareHouse",
          );
        this.setState({
          medicinBatchesdata:
            data.data.data.medication.medication_batches || [],
        });
        const filterPharmacymedicine =
          data.data.data.medication.medication_batches.filter(
            (med) =>
              med.pharmacies && med.pharmacies.name === "Flash Health Pharmacy",
          );
        console.log("Filter Pharmacy Medicine:", filterPharmacymedicine);
        this.state.inputList.map((item, index) => {
          if (item.batch_no === value) {
            item.medicinBatchesdata = filterPharmacymedicine || [];
            item.other_brands = data.data.data.same_generic_medications || [];
          }
        });

        const MEdicineDetails =
          data.data.data.medication.medication_batches.find(
            (item) => item.batch_no === value,
          );
        if (MEdicineDetails) {
          MEdicineDetails.not_fifo = true;
        }
        console.log("MEdicineDetails", MEdicineDetails);

        if (data.data.success) {
          const medicineOption = {
            value: data.data.data.medication.id,
            label:
              data.data.data.medication.title +
              " (" +
              data.data.data.medication.item_code +
              ")" +
              (data.data.data.medication.barcode != null
                ? " - " + data.data.data.medication.barcode
                : ""),
          };
          console.log("medicineOption", medicineOption);
          const newData = await searchMedicationById(obj, medicineOption.value);
          const setMedicinDetails = this.state.inputList.map((item) => {
            if (item.batch_no === value) {
              return {
                ...item,
                description: medicineOption,
                batch_no: value,
                unitprice: data.data.data.medication.price || "",
                unit_price: data.data.data.medication.price || "",
                item_code: data.data.data.medication.item_code || "",
                total_quantity: data.data.data.medication.total_quantity || "",
                selling_price: data.data.data.medication.price || "",
                qty: 0,
                subtotal:
                  (data.data.data.medication.price || 0) *
                  (item.quantity || 1).toFixed(2),
                location:
                  data.data.data.medication.xcoord &&
                  data.data.data.medication.ycoord
                    ? `${data.data.data.medication.ycoord}${data.data.data.medication.xcoord}`
                    : "",
                batches: {
                  batch_no: MEdicineDetails ? MEdicineDetails.batch_no : "",
                  expiry_date: MEdicineDetails
                    ? MEdicineDetails.expiry_date
                    : "",
                  quantity: 1,
                },
                pharmacyLevelQty: getPharmacyLevelQuantity
                  ? getPharmacyLevelQuantity.quantity
                  : 0,
                storeLevelQty: getStoreLevelQuantity
                  ? getStoreLevelQuantity.quantity
                  : 0,
                generic_name: data.data.data.medication.generic_name || "",
                reOrderLevel: newData && newData.data.data.reorder_level,
                consumtionLevel: newData && newData.data.data.daily_consumption,
              };
            }
            return item;
          });

          this.setState(
            {
              inputList: setMedicinDetails,
            },
            () => {
              // Focus selling price input after state update if this was triggered by barcode scan
              if (scannedIndex !== null) {
                setTimeout(() => {
                  console.log(
                    "Focusing selling price input at index:",
                    scannedIndex,
                  );
                  this.focusSellingPriceInput(scannedIndex, 0);
                }, 300);
              }
            },
          );
        }
      } catch (error) {
        if (error && error.response && error.response.status === 404) {
          this.setState({
            alert: (
              <SweetAlert
                className="order_alert"
                style={{ display: "block", marginTop: "-100px" }}
                onConfirm={() => this.hideAlert()}
                onCancel={() => this.hideAlert()}
                confirmBtnText="OK"
                confirmBtnBsStyle="danger"
              >
                <h4>No medicine found for this batch number.</h4>
              </SweetAlert>
            ),
          });
          return;
        }
        console.error("Error getting batch number:", error);
      }
    }
  };
  BatchNoOnchange(event, index) {
    let value = "";
    value = event.target.value;
    this.state.inputList[index]["batch_no"] = value;
    console.log("batch no", value);
    this.setState({
      batch_no: value,
    });
    this.handleBatchNumber(value, index);
  }
  checkIsExpiaryCloserMedicine(batch, allBatches) {
    if (!batch || !batch.expiry_date || !allBatches || !allBatches.length) {
      return false;
    }

    const currentExpiry = moment(batch.expiry_date);
    if (!currentExpiry.isValid()) {
      return false;
    }

    const checkIsNotFifo = allBatches.some((item) => {
      if (item === batch || !item || !item.expiry_date) {
        return false;
      }

      const otherExpiry = moment(item.expiry_date);
      if (!otherExpiry.isValid()) {
        return false;
      }

      return !currentExpiry.isBefore(otherExpiry);
    });

    console.log("checkIsNotFifo", checkIsNotFifo);
    return checkIsNotFifo;
  }
  focusSellingPriceInput = (index, batchIndex) => {
    try {
      console.log("focusSellingPriceInput called with index:", index);
      console.log(
        "sellingPriceInputRef.current:",
        this.sellingPriceInputRef.current,
      );

      let inputElement =
        this.qtyInputRef.current && this.qtyInputRef.current[index][batchIndex];
      console.log("Ref element at index:", index, "element:", inputElement);

      // If the element is a React component (FormControl), try to get the actual DOM input
      if (inputElement && inputElement.refs && inputElement.refs.input) {
        console.log("Found FormControl with refs.input");
        inputElement = inputElement.refs.input;
      } else if (inputElement && inputElement._reactInternalFiber) {
        // Try to access the actual DOM node from the React fiber
        const fiberNode = inputElement._reactInternalFiber;
        if (fiberNode && fiberNode.child) {
          let currentFiber = fiberNode.child;
          while (currentFiber) {
            if (
              currentFiber.elementType === "input" ||
              currentFiber.type === "input"
            ) {
              inputElement = currentFiber.stateNode;
              console.log("Found input through fiber traversal");
              break;
            }
            currentFiber = currentFiber.child;
          }
        }
      }

      if (inputElement) {
        console.log(
          "Final element type:",
          inputElement.tagName || "not a DOM element",
        );
        console.log("Has focus method:", typeof inputElement.focus);
      }

      if (inputElement && typeof inputElement.focus === "function") {
        console.log("Focusing selling price input");
        inputElement.focus();
      } else {
        console.log("Element is not valid or does not have focus method");
      }
    } catch (error) {
      console.error("Error focusing selling price input:", error);
    }
  };
  setBarcodeRef = (el, index) => {
    if (!this.barcodeInputRef.current) {
      this.barcodeInputRef.current = {};
    }
    this.barcodeInputRef.current[index] = el;
  };
  setQtyRef = (el, index, idx) => {
    if (!this.qtyInputRef.current) {
      this.qtyInputRef.current = {};
    }
    if (!this.qtyInputRef.current[index]) {
      this.qtyInputRef.current[index] = {};
    }
    this.qtyInputRef.current[index][idx] = el;
  };
  handleQuantityChange = (idx, index, event) => {
    const value = Number(event.target.value);
    const updatedInputList = [...this.state.inputList];
    updatedInputList[index].medicinBatchesdata[idx].qty = value;
    updatedInputList[index].quantity = updatedInputList[
      index
    ].medicinBatchesdata.reduce((sum, batch) => sum + (batch.qty || 0), 0);
    updatedInputList[index].subtotal = (
      (updatedInputList[index].unitprice || 0) *
      (updatedInputList[index].quantity || 1)
    ).toFixed(2);

    updatedInputList[index].batches =
      updatedInputList[index].medicinBatchesdata[idx];
    const getBatches = updatedInputList[index].medicinBatchesdata.map(
      (batch) => {
        return {
          ...batch,

          batch_no: batch.batch_no,
          expiry_date: batch.expiry_date,
          quantity: batch.qty,
          storeId: batch.pharmacies ? batch.pharmacies.id : null,
        };
      },
    );

    updatedInputList[index].batches = getBatches;
    this.setState({ inputList: updatedInputList });
  };

  handleStatusFilterChange = (status) => {
    this.setState({ grnStatus: status });
  };

  renderStatusBadge = (status) => {
    const normalizedStatus = (status || "").toLowerCase();
    const badgeStyle = {
      padding: "auto",
      width: "auto",
      textTransform: "capitalize",
      cursor: "default",
      pointerEvents: "none",
      opacity: 1,
      border: "none",
    };

    if (normalizedStatus === "approved") {
      return (
        <Button className="badge-fill fl_text_green" style={badgeStyle}>
          Approved
        </Button>
      );
    }

    if (normalizedStatus === "submitted") {
      return (
        <Button className="badge-fill fl_text_orange" style={badgeStyle}>
          Submitted
        </Button>
      );
    }

    return status || "-";
  };

  render() {
    console.log("Medicines", this.state.inputList);
    const errormessages = this.state.errormessages;
    return (
      <div className="main-content">
        {this.state.pdfloading ? <LoadingPdfSpinner /> : ""}
        <Grid fluid>
          {this.state.alert}
          <Card
            content={
              <Row>
                <Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{ marginBottom: "40px" }}
                >
                  <Row>
                    <Col xs={2} sm={2} md={2} lg={2} className="text-left">
                      <Button
                        style={{ marginTop: "25px" }}
                        className="fl_mb_web_1 fl_mb_1 w_150 btn-color"
                        onClick={this.openModal}
                      >
                        <i className="fa fa-file" style={{ color: "red" }}></i>{" "}
                        Return Note
                      </Button>
                      &nbsp;
                    </Col>
                  </Row>
                </Col>
                <Col md={12} sm={12} lg={12} xs={12}>
                  <Table responsive className="order_list_table_show">
                    <thead>
                      <tr>
                        <th>#ID</th>
                        <th>User</th>
                        <th>Total</th>
                        <th>status</th>
                        <th>pdf url</th>
                        <th>Created At</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.loading ? (
                        <tr>
                          <td colSpan="10">
                            <LoadingSpinner />
                          </td>
                        </tr>
                      ) : this.state.noRecordFound ? (
                        <tr>
                          <td colSpan="10">
                            <center>No record found</center>
                          </td>
                        </tr>
                      ) : (
                        <React.Fragment>
                          {this.state.getGoodReturnValue
                            .filter((x) => !x.deleted_at)
                            .filter((x) => {
                              if (!this.state.filterStatus) return true;
                              return (
                                x.status &&
                                x.status
                                  .toLowerCase()
                                  .includes(
                                    this.state.filterStatus.toLowerCase(),
                                  )
                              );
                            })
                            .map((x) => (
                              <tr key={x.id}>
                                <td>{x.id}</td>
                                <td>{x.supplier ? x.supplier.name : ""}</td>
                                <td>{x.total}</td>
                                <td>{this.renderStatusBadge(x.status)}</td>
                                <td>
                                  {x.pdf_url ? (
                                    <Button
                                      onClick={() => this.viewPDF(x.pdf_url)}
                                    >
                                      View
                                    </Button>
                                  ) : null}
                                </td>
                                <td>{x.created_at}</td>
                                <td>
                                  <Button
                                    bsStyle="info"
                                    bsSize="sm"
                                    onClick={() =>
                                      this.handleEditGoodReturnNote(x)
                                    }
                                  >
                                    <i className="fa fa-edit"></i> Edit
                                  </Button>
                                  <Button
                                    bsStyle="danger"
                                    bsSize="sm"
                                    style={{ marginLeft: "6px" }}
                                    onClick={() =>
                                      this.confirmDeleteGoodReturnNote(x.id)
                                    }
                                  >
                                    <i className="fa fa-trash"></i> Delete
                                  </Button>
                                </td>
                              </tr>
                            ))}
                        </React.Fragment>
                      )}
                    </tbody>
                  </Table>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Pagination bsSize="medium">
                      {this.paginationHandler()}
                    </Pagination>
                  </div>
                </Col>
              </Row>
            }
          />
        </Grid>
        {this.state.isLoading ? <ScreenLoader /> : ""}
        <Modal
          show={this.state.showGrnPop}
          onHide={() => this.setState({ showGrnPop: false })}
          bsSize="large"
          backdrop="static"
          id="increaseWidth"
          style={{ width: "100% !important" }}
        >
          <Modal.Header>
            <Modal.Title>Good Return Note</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col xs={12} sm={12} md={12} lg={12}>
                <Row>
                  <Col xs={4} sm={4} md={4} lg={4} className="text-left">
                    <div
                      onKeyUp={(e) => this.inputOnChangeUser(e)}
                      className="Appy2"
                      style={{ textTransform: "capitalize" }}
                    >
                      <Select
                        style={{ textTransform: "capitalize" }}
                        className="react-select primary"
                        classNamePrefix="react-select"
                        name="name"
                        value={
                          this.state.user_detail.id
                            ? {
                                label: this.state.user_detail.label,
                              }
                            : null
                        }
                        onChange={(value) => this.onUserChange(value)}
                        options={this.state.searchUser}
                        placeholder="Select Supplier"
                        noOptionsMessage={() => "Type User Name"}
                      />
                      {this.state.user_detailsError}
                    </div>
                  </Col>
                  <Col xs={2} sm={2} md={2} lg={2} className="text-left">
                    <Button
                      className="fl_mb_web_1 btn-fill fl_mb_1 w_150 btn-color"
                      onClick={() => {
                        this.setState({
                          searchUser: [],
                          user_detail: "",
                        });
                      }}
                    >
                      Reset
                    </Button>
                  </Col>
                  <Col xs={2} sm={2} md={2} lg={2} className="text-left">
                    <FormGroup>
                      <select
                        className="form-control"
                        value={this.state.grnStatus}
                        onChange={(e) =>
                          this.handleStatusFilterChange(e.target.value)
                        }
                      >
                        <option value="submitted">Submitted</option>
                        <option value="approved">Approved</option>
                      </select>
                    </FormGroup>
                  </Col>
                  <div>
                    <Col
                      xs={4}
                      sm={4}
                      md={4}
                      lg={4}
                      className="text-left"
                      style={{ float: "right" }}
                    >
                      <Select
                        name="selectReason"
                        value={this.state.wholeReason}
                        placeholder="Reason for Return"
                        onChange={(e) => this.handleWholeReasonChange(e)}
                        options={[
                          { value: "Wrong Goods", label: "Wrong Goods" },
                          { value: "Excess Goods", label: "Excess Goods" },
                          { value: "Damage Goods", label: "  Damage Goods" },
                          { value: "Other", label: "Other" },
                        ]}
                      />
                    </Col>
                  </div>
                </Row>
              </Col>

              <div>
                <Col
                  xs={4}
                  sm={4}
                  md={4}
                  lg={4}
                  className="text-left"
                  style={{ float: "right", marginRight: "4px" }}
                >
                  {this.state.wholeReason.value === "Other" && (
                    <FormGroup style={{ flex: "1 1 100%", marginTop: "8px" }}>
                      <FormControl
                        as="textarea"
                        style={{
                          width: "100%",
                          padding: "8px",
                          height: "50px",
                          border: "1px solid #e3e3e3",
                          borderRadius: "4px",
                          color: "#565656",
                          resize: "none",
                          outline: "none",
                          backgroundColor: "#ffffff",
                        }}
                        placeholder="Reason for Return"
                        value={this.state.globalOtherNote || ""}
                        onChange={(e) => this.handleGlobalOtherNote(e)}
                        rows={4}
                      />
                    </FormGroup>
                  )}
                </Col>
              </div>
            </Row>
            <br />
            <br />
            {this.state.inputList.map((item, index) => (
              <div
                className={`order-item-card ${item.isSelected ? "checked" : ""}`}
              >
                {/* Header Section */}
                <div className="order-item-header-order">
                  <div className="header-left-order">
                    <input
                      type="checkbox"
                      checked={item.isSelected || false}
                      value={item.id}
                      onChange={(e) =>
                        this.handleItemSelectionChange(e, item.id)
                      }
                      className="item-checkbox"
                    />
                    <span className="item-number">{index + 1}</span>
                    <span className="batch-number">
                      {/* add input text field */}
                      <ForwardedFormControl
                        type="text"
                        name="Batch No"
                        placeholder="Batch No"
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #e3e3e3",
                          borderRadius: "22px",
                          color: "#565656",
                          padding: " 8px 12px",
                          height: "40px",
                          boxShadow: "none",
                          width: "100%",
                        }}
                        // onChange={(e) => this.BatchNoOnchange(e)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            this.BatchNoOnchange(e, index);
                            this.toggleExpand(item.id);
                          }
                        }}
                        ref={(ref) => this.setBarcodeRef(ref, index)}
                        // value={this.state.batch_no || ""}
                        // value={poItem.barcode}
                        disabled={item.stockUpdated}
                      />
                    </span>
                    <span className="item-name-order">
                      <AsyncSelect
                        className="react-select primary"
                        classNamePrefix="react-select"
                        name="description"
                        value={item.description || ""}
                        onChange={(value) =>
                          this.handleMedicineSelectChange(value, index)
                        }
                        loadOptions={this.loadMedicationOptions}
                        cacheOptions
                        defaultOptions={false}
                        styles={{
                          control: (base) => ({
                            ...base,
                            borderRadius: "22px",
                          }),
                        }}
                        ref={(ref) => this.setInputRef(ref, index)}
                        placeholder="Medication"
                        noOptionsMessage={() =>
                          "Type Item Name or Code or Barcode"
                        }
                        // isDisabled={item.stockUpdated}
                      />
                    </span>
                  </div>
                  <div className="header-right-order">
                    <div className="price-info" style={{ paddingLeft: "9px" }}>
                      <label>Unit Price</label>
                      <span>{item.unitprice || "0.00"}</span>
                    </div>
                    <div className="price-info sale-price">
                      {/* <label>Sale Price</label> */}
                      {/* <label>Selling Price</label> */}
                      <span>
                        <FormControl
                          // className="no-padding"
                          name="unitprice"
                          style={{
                            borderRadius: "22px",
                            padding: "8px !important",
                          }}
                          onWheel={(e) => e.target.blur()}
                          value={item.unitprice}
                          onChange={(e) =>
                            this.handleInputChange(e, index, "unitprice")
                          }
                          placeholder="0.00"
                          type="number"
                          disabled={item.stockUpdated}
                        />
                      </span>
                    </div>
                    <div className="price-info">
                      <label>Total Qty</label>
                      <span>{item.quantity || ""}</span>
                    </div>
                    <div className="price-info">
                      <label>Sub Total</label>
                      <span>
                        {item.subtotal
                          ? Number(item.subtotal).toFixed(2)
                          : "0.00"}
                      </span>
                    </div>
                    <button
                      className="remove-btn"
                      onClick={() =>
                        this.handleRemoveClick(
                          index,
                          item.orderItemNumber,
                          item,
                        )
                      }
                    >
                      X
                    </button>
                  </div>
                </div>
                <br />
                {/* Toggle Bar */}
                <div className="order-item-toggle">
                  {item.medicinBatchesdata &&
                    item.medicinBatchesdata.length > 0 && (
                      <>
                        <div className="item-info-field checkbox-field">
                          <label
                            className="toggle-label"
                            style={{
                              fontWeight: "bold",
                              fontSize: "16px",
                            }}
                          >
                            {this.state.expandedId === item.id
                              ? "Hide"
                              : "Show"}
                          </label>
                          <div
                            className="show-hide-checkbox"
                            onClick={(event) => {
                              event.preventDefault();
                              event.stopPropagation();
                              this.toggleExpand(item.id);
                            }}
                          >
                            {this.state.expandedId === item.id ? "-" : "+"}
                          </div>
                        </div>
                        <div className="item-info-row">
                          <div className="item-info-field checkbox-field">
                            <label
                              className="toggle-label"
                              style={{
                                fontWeight: "bold",
                                fontSize: "16px",
                              }}
                            >
                              Pharmacy Stock
                            </label>
                            <span
                              style={{
                                color:
                                  (item.pharmacyLevelQty || 0) > 0
                                    ? "green"
                                    : "red",
                              }}
                            >
                              {item.pharmacyLevelQty || 0}
                            </span>
                          </div>
                          <div className="item-info-field checkbox-field">
                            <label
                              className="toggle-label"
                              style={{
                                fontWeight: "bold",
                                fontSize: "16px",
                              }}
                            >
                              Store Stock
                            </label>
                            <span
                              style={{
                                color:
                                  (item.storeLevelQty || 0) > 0
                                    ? "green"
                                    : "red",
                              }}
                            >
                              {item.storeLevelQty || 0}
                            </span>
                          </div>
                        </div>
                      </>
                    )}
                </div>

                <div className="order-item-content">
                  {/* Stock Availability Section */}
                  <div className="stock-section-order">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        marginLeft: "5px",
                      }}
                    >
                      <div className="section-header-order">
                        STOCK AVAILABILITY
                      </div>
                      {/* Warehouse Stock Section */}
                    </div>

                    {/* Stock Table */}
                    {item.medicinBatchesdata &&
                      item.medicinBatchesdata.length > 0 &&
                      this.state.expandedId === item.id && (
                        <table className="stock-table-order">
                          <thead>
                            <tr>
                              <th>Batch</th>
                              <th>Expiry</th>
                              <th className="align-center">Available Qty</th>
                              <th className="align-center">Location</th>
                              <th className="align-center">Qty</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {item.medicinBatchesdata &&
                            item.medicinBatchesdata.length > 0 ? (
                              item.medicinBatchesdata.map((stock, idx) => (
                                <tr
                                  key={idx}
                                  className={
                                    stock.isSelectedBatch ||
                                    stock.batch_no === item.batch_no
                                      ? "not-fifo"
                                      : ""
                                  }
                                >
                                  <td>
                                    {stock.batch_no !== ""
                                      ? stock.batch_no
                                      : "N/A"}
                                  </td>
                                  <td>
                                    {stock.expiry_date !== ""
                                      ? stock.expiry_date
                                      : "N/A"}
                                  </td>
                                  <td className="align-center">
                                    {stock.quantity}
                                  </td>
                                  <td className="align-center">
                                    {(stock.pharmacies &&
                                      stock.pharmacies.name) ||
                                      "-"}
                                  </td>
                                  <td className="align-center">
                                    <FormControl
                                      type="number"
                                      value={stock.qty || ""}
                                      onChange={(e) =>
                                        this.handleQuantityChange(idx, index, e)
                                      }
                                      onWheel={(e) => e.target.blur()}
                                      className="qty-input align-center"
                                      ref={(ref) =>
                                        this.setQtyRef(ref, index, idx)
                                      }
                                      onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                          this.focusSellingPriceInput(
                                            index,
                                            idx + 1,
                                          );
                                        }
                                      }}
                                      disabled={item.stockUpdated}
                                    />
                                  </td>
                                  <td className="align-center">
                                    {item.batch_no === stock.batch_no &&
                                      this.checkIsExpiaryCloserMedicine(
                                        stock,
                                        item.medicinBatchesdata,
                                      ) && (
                                        <span className="not-fifo-badge">
                                          ⚠ Not FIFO
                                        </span>
                                      )}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan="6"
                                  style={{
                                    textAlign: "center",
                                  }}
                                >
                                  No stock available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      )}
                  </div>
                </div>

                <div style={{ padding: "0 20px" }}>
                  <hr
                    style={{
                      border: "2px solid #ff9800",
                      margin: "10px 0",
                      width: "100%",
                    }}
                  />
                </div>
              </div>
            ))}
            <Button className="add-medicine-btn" onClick={this.handleAddClick}>
              {" "}
              <i className="fa fa-plus"></i> Add Medicine
            </Button>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.onSubmit.bind(this)} bsStyle="success" fill>
              Submit
            </Button>
            <Button bsStyle="danger" fill onClick={this.closeModal}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
export default goodReturnNote;
